export const inDevelopment = () => process.env.NODE_ENV === "development";
export const inProduction = () => process.env.NODE_ENV === "production";
export const inTest = () => process.env.NODE_ENV === "test";
export const inDebug = () => process.env.REACT_APP_DEBUG === "on";
